import React from 'react';
import { Link } from 'react-router';
import { Row, Col, Button, Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import editcampaign from '../../images/edit-campaign.png';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import PaginatedList from '../../components/PaginatedList';
import SidebarFilterBox from '../../components/SidebarFilterBox';

export default class ShapeSetSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
    this.fuzzyFilterFactory = fuzzyFilterFactory();
    this.updateFilterValue = this.updateFilterValue.bind(this);
  }

  updateFilterValue(filterValue) {
    this.setState({ filterValue: filterValue || '' });
  }

  moveFocusToHeading = item => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  render() {
    const shapeSetId = this.props.params.shapeSetId || 'new';
    const { context, organisationId = 0 } = this.props.params;
    const shapeSetBaseUrl = `/${context}/${organisationId}/catchment-sets`;

    const LineItem = props => {
      const shapeSet = props.item;
      return (
        <Row
          key={shapeSet.id}
          className={`sidebar-list-item ${shapeSet.isArchived && 'archived'}`}
          onClick={e => this.moveFocusToHeading(shapeSet)}
        >
          <Link to={`${shapeSetBaseUrl}/${shapeSet.id}`}>
            <Col
              sm={10}
              className={`overflow-ellipsis map-link ${shapeSetId ===
                shapeSet.id.toString() && 'active'}`}
            >
              <p title={shapeSet.name}>
                <strong>{shapeSet.name}</strong>
              </p>
              <small title={`Created by ${shapeSet.createdBy}`}>
                Created by {shapeSet.createdBy}
              </small>
            </Col>
          </Link>
          <Link to={`${shapeSetBaseUrl}/${shapeSet.id}`}>
            <Col sm={2} className="edit-btn text-center campaign-edit-link">
              <Image src={editcampaign} responsive alt="Edit Campaign" />
              <span className="campaign-edit-link-text">Edit</span>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={6}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing catchment set {this.state.currentItemName}
            </h3>
            <h1 className="too-long">Catchment Sets</h1>
          </Col>
          <Col sm={12} md={6}>
            <LinkContainer to={`${shapeSetBaseUrl}/new`}>
              <Button bsStyle="primary" className="new-btn">
                Create New
              </Button>
            </LinkContainer>
          </Col>
          <Col sm={12} md={12}>
            <SidebarFilterBox
              onChange={this.updateFilterValue}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <PaginatedList
              filterValue={this.state.filterValue}
              itemsPerPage={10}
              component={LineItem}
              pageButtonLimit={5}
              items={this.props.items}
              showArchived={this.state.showArchived}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
              context={context}
              pluralName="catchment sets"
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="archiveCheckbox"
                id="archiveCheckbox"
                className="archive-checkbox"
                checked={this.state.showArchived}
                onChange={() =>
                  this.setState({ showArchived: !this.state.showArchived })
                }
              />
              <label htmlFor="archiveCheckbox" className="checkbox-label">
                Show Archived
              </label>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/shapeset/ShapeSetSidebar.js